// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"3cb55aa6","924":"3277179f"}[chunkId] + ".chunk.js";
};